const Work = () => {
  return (
    <div id="work">
      <h1 className="work-experiences">
        <section>03.</section>Work Experience
      </h1>
      
      <div className="work-item">
        <div className="time">2022 - Present</div>
        <a href="https://www.mriiot.com/" target="_blank" rel="noreferrer">
          <h3 className="company">Mr. IIoT</h3>
        </a>
        <div className="job-title">Full-Stack Software Engineer</div>
        <div className="work-des">
          Currently, I work full-time at a small startup, where I enjoy the flexibility of working with a wide 
          range of technologies, programming languages, and systems. I mainly focus on developing innovative IIoT 
          solutions, including co-creating the SHARC, a universal sensor adapter that helps businesses streamline 
          operations and leverage real-time data insights. I have led projects to replace manual processes with 
          automated, user-friendly systems, saving time and boosting productivity. Additionally, I develop 
          proprietary software for industry-leading enterprises, integrating with PLCs to improve operations, 
          automate complex tasks, and deliver valuable insights that drive better decision-making.
        </div>
      </div>
      
      <div className="work-item">
        <div className="time">2022</div>
        <a href="https://www.hackreactor.com/" target="_blank" rel="noreferrer">
          <h3 className="company">Hack Reactor</h3>
        </a>
        <div className="job-title">Software Engineering Immersive</div>
        <div className="work-des">
          I transitioned into web development in early 2022, initially through self-study and later through 
          Hack Reactor's immersive bootcamp. The bootcamp provided a rigorous, fast-paced learning environment 
          where I gained hands-on experience working independently, in pairs, and within teams. Through this 
          experience, I developed strong technical skills in JavaScript, React, HTML, CSS, AWS, PostgreSQL, 
          MySQL, and MongoDB.
        </div>
      </div>
      
      <div className="work-item">
        <div className="time">2020 - 2022</div>
        <a href="https://en.wikipedia.org/wiki/Day_trading" target="_blank" rel="noreferrer">
          <h3 className="company">Professional Day Trading</h3>
        </a>
        <div className="job-title">Independent Trader</div>
        <div className="work-des">
          After leaving my previous job, I took on professional day trading, where I learned what it really means 
          to be accountable for my decisions. I got used to making quick calls under intense pressure and staying 
          calm and focused even when things were constantly changing. It was a challenging but rewarding experience 
          that taught me how to adapt and perform in high-stakes situations.
        </div>
      </div>
    </div>
  )
}

export default Work;
